var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.model
      ? _c(
          "div",
          [
            _c("h3", [
              _vm._v(_vm._s(_vm.$t("InvestmentReport.Finances.Funding.Title")))
            ]),
            _vm._v(" "),
            _c("lines-and-details", {
              attrs: {
                id: "funding",
                value: _vm.funding,
                required: true,
                showColumnTotals: true
              }
            }),
            _vm._v(" "),
            _vm.showSelfCoveredFundingLoanCondition
              ? _c("radio-button-option-row", {
                  attrs: {
                    title:
                      "InvestmentReport.Finances.Funding.SelfCoveredFundingLoanCondition",
                    required: false,
                    options: _vm.optionsArray("PledgeType", true)
                  },
                  model: {
                    value: _vm.model.funding.selfCoveredFundingLoanCondition,
                    callback: function($$v) {
                      _vm.$set(
                        _vm.model.funding,
                        "selfCoveredFundingLoanCondition",
                        $$v
                      )
                    },
                    expression: "model.funding.selfCoveredFundingLoanCondition"
                  }
                })
              : _vm._e(),
            _vm._v(" "),
            _c("h3", [
              _vm._v(_vm._s(_vm.$t("InvestmentReport.Finances.Expenses.Title")))
            ]),
            _vm._v(" "),
            _vm.apartments
              ? _c(
                  "div",
                  [
                    _c("apartment-acquisitions-control", {
                      attrs: { apartments: _vm.apartments }
                    })
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _c("h3", [
              _vm._v(
                _vm._s(_vm.$t("InvestmentReport.Finances.Attachments.Title"))
              )
            ]),
            _vm._v(" "),
            _c("attachments", {
              attrs: { showActions: true },
              model: {
                value: _vm.attachments,
                callback: function($$v) {
                  _vm.attachments = $$v
                },
                expression: "attachments"
              }
            })
          ],
          1
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }